import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class RecCritique extends Mappeable {

    idTypeCritiqueFactPk: number;
    txtTypeCritiqueFact: string;
    orderNumber: number;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
        this.orderNumber = this.orderNumber ??  0 
    }

    public mapToBack() {
        return {
            txtTypeCritiqueFact: this.txtTypeCritiqueFact,
            mrkActive: this.mrkActive,
            orderNumber: this.orderNumber
        }
    }


}
